<div [hidden]="loadingServerVersion">
    {{serverVersion}}
</div>
